import React from "react";
import LightBox2 from "components/common/LightBox2";
import qs from "query-string";
import navigate from "lib/navigate";

@LightBox2
class ResourceGroupLightBox2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.title !== this.state.title) {
      this.setState({ title: props.title });
    }
  }

  beforeOpen = () => {
    let { search } = this.props;
    let params = { ...search };
    let { filterField = [], filterValue = [] } = params;
    filterField = [].concat(filterField || []);
    filterValue = [].concat(filterValue || []);
    let filtersData = {};
    let checkFilter = {};

    filterField.forEach((field, k) => {
      let value = filterValue[k];
      let key = `${value}`;
      checkFilter[key] = true;
      filtersData[key] = {
        field,
      };
    });

    this.setState({
      filtersData,
      checkFilter,
    });
  };

  addFilter = (item) => {
    let { value } = item;
    let { checkFilter, filtersData } = this.state;
    let key = `${value}`;
    if (checkFilter[key]) {
      delete checkFilter[key];
    } else {
      checkFilter[key] = true;
      filtersData[key] = {
        field: this.state.index,
      };
    }
    this.setState({ checkFilter: checkFilter });
  };

  submit = (e) => {
    e.preventDefault();
    let { location, search } = this.props;
    let params = { ...search };
    let OldFilterValue = [].concat(params.filterValue);
    delete params.filterField;
    delete params.filterValue;
    const { checkFilter, filtersData } = this.state;

    let filterField = [],
      filterValue = [];
    Object.keys(checkFilter).map((key) => {
      let { field } = filtersData[key];
      filterField.push(field);
      filterValue.push(key);
      return "";
    });

    let hasNew = false;
    filterValue.forEach((of) => {
      hasNew = hasNew || OldFilterValue.indexOf(of) === -1;
    });

    if (hasNew) {
      delete params.filterPid;
      params.filterField = filterField;
      params.filterValue = filterValue;
      navigate([location.pathname, qs.stringify(params)].join("?"));
    }
  };

  render() {
    let { t, index, close } = this.props;
    let { checkFilter = {} } = this.state;
    return (
      <section className="moreOptions">
        <form onSubmit={this.submit}>
          <div className="optionGroup">
            {this.state.data.map((item) => {
              let { title, cnt, value } = item;
              let titleTemp = t(title);
              if (title !== titleTemp) {
                title = titleTemp;
              }
              return (
                <>
                  <label htmlFor={`${index}-${item.value}`}>
                    <input
                      type="checkbox"
                      id={`${index}-${item.value}`}
                      name={index}
                      value={`${index}-${item.value}`}
                      checked={checkFilter[value]}
                      onChange={this.addFilter.bind(this, item)}
                    />
                    {title}
                    {cnt > -1 && <span className="count">{cnt}</span>}
                  </label>
                </>
              );
            })}
          </div>
          <div className="btnDv stick">
            <button
              type="button"
              tabIndex="0"
              className="btn-reset"
              onClick={(e) => {
                e.preventDefault();
                close();
              }}>
              {t("jumperrwd.common.cancel")}
            </button>
            <button
              type="submit"
              tabIndex="0"
              className="btn-submit"
              onClick={this.submit}>
              {t("jumperrwd.common.confirm")}
            </button>
          </div>
        </form>
      </section>
    );
  }
}

export default ResourceGroupLightBox2;
